<template>
  <div id="top">
    <!-- <banner :bannerUrl="bannerUrl"></banner> -->
    <section class="hero-area">
      <div class="hero-slider">
        <!-- <div class="hero-inner overlay" style="background-image: url(../assets/images/banner01.jpg);"> -->
        <div
          class="breadcrumbs overlay"
          :style="{
            backgroundImage:
              'url(' + require('../assets/images/banner01.jpg') + ')',
          }"
        >
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                <div class="breadcrumbs-content">
                  <h1 class="page-title">
                    {{ $t("banners.guest.h1Content") }}
                  </h1>
                  <p>{{ $t("banners.guest.content") }}</p>
                </div>
                <ul class="breadcrumb-nav">
                  <li>
                    <a style="cursor: pointer" @click="goToIndex()">{{
                      $t("banners.guest.button[0]")
                    }}</a>
                  </li>
                  <li>{{ $t("banners.guest.button[1]") }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="teachers" class="teachers" >
      <div v-for="(item1, index1) in $t('speakerPage.speakerYears')" :key="index1" style="padding-top: 20px;"> 
      <span class="horizontal-line" style="text-align: center;background-color: #f4f7fa;">{{ item1 }}</span>
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12" v-for="(item, index) in $t('speakerPage')[`year${item1}`]" :key="index">
            <div class="single-team wow fadeInUp" data-wow-delay=".2s">
              <div class="row">
                <div class="col-lg-5 col-12">
                  <div class="image">
                    <img
                      :src= item.picUrl
                      alt="#"
                      height="320"
                    />
                  </div>
                </div>
                <div class="col-lg-7 col-12">
                  <div class="info-head">
                    <div class="info-box">
                      <span class="designation">{{item.title}}</span>
                      <h4 class="name">
                        <a href="teacher-details.html">{{item.name}}</a>
                      </h4>
                      <p style="text-indent: 2em">
                        {{item.designation}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <!-- <div style="margin-top: 20px">
            <span class="horizontal-line" style="text-align: center">{{ $t('speakerPage.speakerYears[1]') }}</span>
          </div>

           <div class="col-lg-6 col-md-6 col-12" v-for="(item, index) in $t('speakerPage.year23')" :key="index">
            <div class="single-team wow fadeInUp" data-wow-delay=".2s">
              <div class="row">
                <div class="col-lg-5 col-12">
                  <div class="image">
                    <img :src= item.picUrl alt="#" />
                  </div>
                </div>
                <div class="col-lg-7 col-12">
                  <div class="info-head">
                    <div class="info-box">
                      <span class="designation">{{item.title}}</span>
                      <h4 class="name">
                        <a href="teacher-details.html">{{item.name}}</a>
                      </h4>
                      <p style="text-indent: 2em">
                        {{item.designation}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <a
      href="javascript:void(0)"
      class="scroll-top btn-hover"
      @click="scrollToAnchor('top')"
    >
      <i class="lni lni-chevron-up"></i>
    </a>
  </div>
</template>
  
<script>
import indexnav from "@/components/nav/indexnav.vue";
import banner from "@/components/header/banner.vue";

export default {
  name: "IndexPage",
  components: {
    indexnav,
    banner,
  },
  data() {
    return {
      bannerUrl: ["BANNER.png"],
    };
  },
  mounted() {
    //  TouchSlide({
    // 		slideCell:"#news_slide",
    // 		mainCell:".bd ul",
    // 		effect:"leftLoop",
    // 		autoPlay:true//自动播放
    //  });
    const slide = document.querySelector(".hero-slider");
    console.log(slide);
    tns({
      container: ".hero-slider",
      items: 1,
      slideBy: "page",
      autoplay: false,
      mouseDrag: true,
      gutter: 0,
      nav: true,
      controls: false,
      controlsText: [
        '<i class="lni lni-arrow-left"></i>',
        '<i class="lni lni-arrow-right"></i>',
      ],
    });
    document.addEventListener("click", (evnt) => {
      let anchor = evnt.target.closest('a[href^="#"]');
      if (anchor) {
        evnt.preventDefault();
        let value = anchor.getAttribute("set_data");
        if (value) {
          this.newsDetail(value);
        }
      }
    });
  },
  methods: {
    scrollToAnchor(id) {
      var anchor = document.getElementById(id);
      anchor.scrollIntoView();
    },
    goToIndex() {
      this.$router.push({
        path: "/index",
      });
    },
    newsDetail(index) {
      console.log(11111);
      this.$router.push({
        path: "/newsDetail/" + index,
      });
    },
    caseDetail(type) {
      this.$router.push({
        path: "/caseDetail/" + type,
      });
    },
  },
};
</script>
  
<style>
.horizontal-line {
  display: inline-block;
  width: 100%;
  border-bottom: 1px solid;
}

/* ========= 整条高度链打通：col-lg-6 → single-team → 内部 row → 右列 col-lg-7 → info-box → p ========= */

/* 1. 外层 row（v-for 所在的 Bootstrap row）已是 flex，让子 col-lg-6 高度拉齐并撑满 */
#teachers .row > .col-lg-6,
#teachers .row > .col-md-6 {
  display: flex;
}

/* 2. single-team 撑满父列 */
.single-team {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* 3. single-team 内部 row 撑满 single-team */
.single-team > .row {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;  /* 左右两列等高拉伸 */
}

/* 4. 左右两列都撑满高度 */
.single-team > .row > [class*="col-"] {
  display: flex;
}

/* 5. 右侧信息列纵向 flex */
.single-team > .row > .col-lg-7 {
  flex-direction: column;
}

/* 6. info-head / info-box 纵向 flex，占满剩余空间 */
.single-team .info-head {
  flex: 1;
  display: flex;
}
.single-team .info-box {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 7. 简介 p 标签自动撑满剩余空间 */
.single-team .info-box p {
  flex: 1;
  margin-bottom: 0;
  /* 让数据中的 \n 换行符生效，同时保留正常自动换行 */
  white-space: pre-line;
}
</style>